<template>
  <RegisterSection :show-header="true"></RegisterSection>
</template>
<script>
import RegisterSection from "@/Layout/RegisterSection";
export default {
  name:"Register",
  components: {RegisterSection}
}
</script>